export const formatTaxId = (taxId: string): string =>
    taxId.includes('-')
        ? taxId
        : taxId.substring(0, 2).concat('-', taxId.substring(2));
